<template>
  <a-card title="职位管理"
          :bordered="false"
          :loading="loading"
          style="width: 100%;overflow:hidden">
    <template #extra>
      <a-button @click="refreshData"
                size="normal">刷新</a-button>
      <a-button @click="createOrganization" v-p="'/authorizations/positions:POST'"
                size="normal">创建职位</a-button>
    </template>
    <AuthTree v-if="refreshType"
              :idKey="rbac.$state.models.role[0].id"
              sourceUrlKey="positions"
              targetUrlKey="roles"
              :rightMenu="rightMenu"
              @pageFn="getId"
              resultKey="positions"
              :checkbox="checkbox">
    </AuthTree>
    <a-modal v-model:visible="createOrganizationVisible"
             title="新建职位"
             :confirm-loading="confirmLoading"
             @ok="createUserConfirm">
      <a-form :model="createorganizationForm"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 24 }">
        <a-form-item label="名称"
                     name="name"
                     :rules="[{ required: true, message: '请输入名称' }]">
          <a-input v-model:value="createorganizationForm.name" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script setup lang="ts">
import { CORE_AXIOS, Http } from '@/core'
import { message } from 'ant-design-vue'
import { container } from 'tsyringe'
import { reactive, ref } from 'vue'
import { useRbacStore } from '../../DefaultRbacPagePlugin'
import AuthTree from '../menu/AuthTree.vue'
const axios = container.resolve<Http>(CORE_AXIOS)
const rbac = useRbacStore()
const checkbox = false
const rightMenu = true
const refreshType = ref<boolean>(true)
const createorganizationForm = reactive({
  name: '',
  key: ""
})
const loading = ref<boolean>(false)
const createOrganizationVisible = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)

//刷新 Func
const refreshData = () => {
  refreshType.value = false
  setTimeout(() => {
    refreshType.value = true
  }, 50)
}

//创建角色 Func
const createOrganization = () => {
  createOrganizationVisible.value = true
}

//创建角色 确认 Func
const createUserConfirm = () => {
  const { name } = createorganizationForm
  axios.post('/v1/api/authorizations/positions', { name }).then(() => {
    confirmLoading.value = false
    createOrganizationVisible.value = false
    message.success('添加成功！')
    refreshData()
  })
}

const getId = (value: string) => {
  rbac.$patch((state) => {
    state.models.position.length = 0
    state.models.position.push(value)
  })
}


</script>

<style lang="less" scoped>
:deep(.ant-table) {
  height: 76.4vh;
}
</style>
